/**
 * @generated SignedSource<<62a0dd1937d42f3b195ae0d13de0d6d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type printAreaEditorDialogQuery$variables = {
  productIDs?: ReadonlyArray<string> | null;
};
export type printAreaEditorDialogQuery$data = {
  readonly printAreaTemplates: ReadonlyArray<{
    readonly height: number;
    readonly name: string;
    readonly templateID: number;
    readonly width: number;
  }>;
  readonly productIDsWithTemplates: ReadonlyArray<{
    readonly productID: string;
    readonly templateCount: number;
  }>;
};
export type printAreaEditorDialogQuery = {
  response: printAreaEditorDialogQuery$data;
  variables: printAreaEditorDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIDs"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateID",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "productIDs",
      "variableName": "productIDs"
    }
  ],
  "concreteType": "ProductWithTemplateCount",
  "kind": "LinkedField",
  "name": "productIDsWithTemplates",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateCount",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "printAreaEditorDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PrintAreaTemplate",
        "kind": "LinkedField",
        "name": "printAreaTemplates",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "printAreaEditorDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PrintAreaTemplate",
        "kind": "LinkedField",
        "name": "printAreaTemplates",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ]
  },
  "params": {
    "cacheID": "3d23efb5b4cb6c01c7be96d0e1e27948",
    "id": null,
    "metadata": {},
    "name": "printAreaEditorDialogQuery",
    "operationKind": "query",
    "text": "query printAreaEditorDialogQuery(\n  $productIDs: [String!]\n) {\n  printAreaTemplates {\n    templateID\n    name\n    width\n    height\n    id\n  }\n  productIDsWithTemplates(productIDs: $productIDs) {\n    productID\n    templateCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "a01f76cbdecd57c1ce9e3c38de2317df";

export default node;
